import { render, staticRenderFns } from "./PopupFormFolder.vue?vue&type=template&id=1ccf9e41"
import script from "./PopupFormFolder.vue?vue&type=script&lang=js"
export * from "./PopupFormFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports